/* eslint-disable */
// import anime from 'animejs'
// import axios from 'axios'
import { get as getPipe } from '../utils/sigpipe'

import translate from '../translations'

export default {
  name: 'card-activity',

  ui: {
    btDelete: '[js-card-delete]',
  },

  events: [
    {
      target: 'btDelete',
      on: 'click',
      handle() {
        if (confirm(translate('CONFIRM_DELETE'))) {
          const that = this
          this.pipe.write({ action: 'activity-removed', data: that })
        } else {
        }
      },
    },
  ],

  componentDidMount() {
    const pipeId = this.el
      .closest('.page-member__block')
      .getAttribute('data-pipe-id')
    this.pipe = getPipe(pipeId)
  },
}
